var exports = {
  "fs": "VisualTab.module__sliderSection___aTUyc1",
  "Ry": "VisualTab.module__sliderHeader___aTUyc1",
  "mr": "VisualTab.module__sliderTitleRow___aTUyc1",
  "KF": "VisualTab.module__sliderLabel___aTUyc1",
};

module.exports = exports;
